<template>
  <div class="vault-table">
    <div
      class="d-flex align-center bg-vaults-lighter has-border border-vault rounded-8 gray--text text-6 font-weight-medium px-6 py-2"
    >
      <div class="flex-2">Vaults</div>
      <div class="flex-2 text-right">Vault Balance</div>
      <div class="flex-2 text-right">Strategy Balance</div>
      <div class="flex-2 text-right">Total Value Locked</div>
      <div class="flex-2 text-right">3-Days Avg Yield</div>
      <div class="flex-2 text-right">15-Days Avg Yield</div>
      <div class="flex-1 text-right">Ecosystem</div>
    </div>
    <vault-row
      v-for="(item, index) in vaultItems"
      :key="item.type + item.token"
      :dataItem="item"
      :hasDivider="index > 0"
    />
  </div>
</template>

<script>
import VaultRow from "./VaultRow.vue";

export default {
  components: {
    VaultRow,
  },
  props: {
    vaultItems: Array,
  },
};
</script>
